import React from 'react';
import { RootState } from 'reducer';
import { useDispatch, useSelector } from 'react-redux';
import { rewardOnboarding } from 'theme';
import Dialog from 'seedly-component-library/dialog';
import Button from 'seedly-component-library/button-new';
import ModalActions from 'reducer/modalRedux';
import Image from 'next/image';

const RedeemRewardFailureModal = () => {
  const dispatch = useDispatch();
  const isOpen = useSelector(
    (state: RootState) => state.modal.isClaimRewardFailureModalOpen,
  );

  return (
    <Dialog
      isOpen={isOpen}
      widthSize="sm"
      onCloseClick={() =>
        dispatch(ModalActions.setClaimRewardFailureModal(false))
      }
      isMobileFullHeight={false}
    >
      <div className="flex flex-col w-full items-center gap-4">
        <Image src={rewardOnboarding.error} height={240} width={240} />
        <div className="flex flex-col w-full items-center">
          <p className="text-center text-sm font-bold">
            Oops…something went wrong
          </p>
          <p className="text-center">
            Refresh the page and check if the reward is still available for
            redemption. If you&apos;re still facing issues, do reach out to us
            at{' '}
            <a
              className="text-blue-500 hover:text-blue-500"
              href="mailto:support@seedly.sg"
            >
              support@seedly.sg
            </a>
          </p>
        </div>
        <Button
          variant="outline"
          onClick={() => {
            window.location.reload();
          }}
        >
          Refresh Page
        </Button>
      </div>
    </Dialog>
  );
};

export default RedeemRewardFailureModal;
